import { Translation } from '@ps/web-shared-components';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';
import { select } from '@swf/core/store';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../../ChestInventory.scss';
import ChestBalance from '../ChestBalance/ChestBalance';
import Grid from '../Grid/Grid';

import { TXTWCL_You_currently_donXt_have_any_C_ELL_1 } from './ChestGrid.messages.json';

interface Props {
  showBalance?: boolean;
  onLoad?: () => void;
}

const ChestGrid: React.FC<Props> = ({ showBalance = true, onLoad }) => {
  const { data } = useSelector(select.chestInventory.get);
  const chests = data?.chests || [];
  const availableCount = data?.availableCount || 0;

  useEffect(() => {
    if (data && onLoad) {
      onLoad();
    }
  }, [data, onLoad]);

  return (
    <LoadingIndicator loading={!data && !onLoad}>
      {isEmpty(chests) ? (
        <div className={styles.message}>
          <Translation {...TXTWCL_You_currently_donXt_have_any_C_ELL_1} />
        </div>
      ) : (
        <>
          {showBalance && <ChestBalance availableCount={availableCount} />}
          <Grid chests={chests} />
        </>
      )}
    </LoadingIndicator>
  );
};

export default ChestGrid;
